import { Component, HostListener, TemplateRef } from '@angular/core';
import { ShivePopupService } from '../../../../core/services/controls/shive-popup.service';
import { ContextMenuItem } from '../../../data-types/context-menu-item-type';

@Component({
  selector: 'app-shive-context-menu',
  templateUrl: './shive-context-menu.component.html',
  standalone: false,
})
export class ShiveContextMenuComponent {
  public contextMenuItems: ContextMenuItem[] = [];
  public data: any;
  public header: TemplateRef<HTMLElement> | null = null;
  public footer: TemplateRef<HTMLElement> | null = null;

  constructor(private readonly shivePopupService: ShivePopupService) {}

  @HostListener('document:keydown', ['$event'])
  public keydown(event: KeyboardEvent): void {
    if (event.code === 'Escape') {
      this.shivePopupService.close();
    }
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: PointerEvent): void {
    if (!this.shivePopupService.contains(event.target as Node)) {
      this.shivePopupService.close();
    }
  }

  public click(item: ContextMenuItem): void {
    item.callback(this.data);
    this.shivePopupService.close();
  }

  public isVisible(item: ContextMenuItem): boolean {
    if (typeof item.isVisible === 'boolean') {
      return item.isVisible;
    }
    return item.isVisible(this.data);
  }

  public isActived(item: ContextMenuItem): boolean {
    if (typeof item.isActivated === 'boolean') {
      return item.isActivated;
    }

    return item.isActivated(this.data);
  }
}
